/**
 * Which paths the router's authentication guard covers.
 *
 * It used to be a bare `startsWith('/dashboard')` in one navigation guard,
 * which was accurate right up to the moment a session-authenticated page
 * landed anywhere else. The OAuth consent screen is exactly that page: it
 * decides what standing authority a third-party agent gets over the account,
 * and an unauthenticated visitor reaching it would see a consent form with no
 * account behind it.
 *
 * Prefix matching is on whole segments. `/dashboardish` is not the dashboard,
 * and a guard that thinks it is quietly widens every later prefix added here.
 */
export const AUTHENTICATED_PATH_PREFIXES = ['/dashboard', '/oauth'] as const

/** Whether `path` needs a signed-in session. */
export const routeRequiresAuth = (path: string): boolean =>
  AUTHENTICATED_PATH_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))
